import React, { useState } from 'react';

// A generic collapsible panel -- the repeated shape behind a product's repo
// explorer, sources list, plans list, etc. (spec: "Reusable shell
// components"). Deliberately has no product-specific content; each product
// supplies its own children.
export function OziraShellDrawer({
  title, children, defaultOpen = true, side = 'start',
}: {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  side?: 'start' | 'end';
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className={`ozira-shell-drawer ozira-shell-drawer--${side}${open ? ' is-open' : ''}`}>
      <button
        type="button"
        className="ozira-shell-drawer__toggle"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        {title}
      </button>
      {open ? <div className="ozira-shell-drawer__body">{children}</div> : null}
    </section>
  );
}
